// Indonesia Western Time (WIB, UTC+7) date helpers.
// Avoids UTC off-by-one so "today" always matches the WIB calendar.
export const WIB_OFFSET_MS = 7 * 60 * 60 * 1000;

export const wibShift = (offset = 0) =>
  new Date(Date.now() + WIB_OFFSET_MS + offset * 86400000).toISOString().slice(0, 10);

export const wibToday = () => wibShift(0);

// Convert ISO "yyyy-mm-dd" <-> Date (local, no tz shift) and display as dd/mm/yyyy.
export const isoToDate = (iso) => {
  if (!iso) return undefined;
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const dateToIso = (dt) => {
  if (!dt) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const d = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const formatDMY = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};
